import React from 'react';
import BibliaRespondeLanding from './components/BibliaRespondeLanding';
import './App.css';

function App() {
  return (
    <div className="App">
      <BibliaRespondeLanding />
    </div>
  );
}

export default App;
